// extracted by mini-css-extract-plugin
export default {"SignUpTitle":"Signup_SignUpTitle__9mSHs","Input":"Signup_Input__HdxJT"};